import React, { useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminTopBar from "./AdminTopBar";
import { useNavigate } from "react-router-dom";
import api from "./api/axios";
import { useActivityLogger } from "./hooks/useActivity";
export default function AdminAddCommunity() {
  const navigate = useNavigate();
  const [imagePreview, setImagePreview] = useState(null);
  const { logAdminActivity } = useActivityLogger();
  const [formData, setFormData] = useState({
    nama_komunitas: "",
    nomor_hp: "",
    website: "",
    facebook: "",
    instagram: "",
    whatsapp: "",
    twitter: "",
    tiktok: "",
    telegram: "",
    image: null,
  });

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImagePreview(URL.createObjectURL(file));
      setFormData({ ...formData, image: file });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (!formData.nama_komunitas || !formData.nomor_hp) {
      alert("Nama komunitas dan nomor HP wajib diisi!");
      return;
    }
  
    const payload = new FormData();
    
    // Append data with explicit values
    payload.append("nama_komunitas", formData.nama_komunitas);
    payload.append("nomor_hp", formData.nomor_hp);
    
    // Only append optional fields if they have values
    if (formData.website) payload.append("website", formData.website);
    if (formData.facebook) payload.append("facebook", formData.facebook);
    if (formData.instagram) payload.append("instagram", formData.instagram);
    if (formData.whatsapp) payload.append("whatsapp", formData.whatsapp);
    if (formData.twitter) payload.append("twitter", formData.twitter);
    if (formData.tiktok) payload.append("tiktok", formData.tiktok);
    if (formData.telegram) payload.append("telegram", formData.telegram);
    if (formData.image) payload.append("image", formData.image);
  
    // Debug: Log what's being sent
    console.log("Form data being sent:");
    for (let [key, value] of payload.entries()) {
      console.log(key, value);
    }
  
    try {
      const response = await api.post("/komunitas", payload, {headers: { "Content-Type": "multipart/form-data" },});
      console.log("Response:", response.data);
      logAdminActivity(
        "admin",
        "add_community", 
        "community",
        response.data.ID,
        "success",
        `Added community: ${formData.nama_komunitas}`,
        formData.nama_komunitas // content title
      );
      alert("Komunitas berhasil ditambahkan");
      navigate(-1);
    } catch (error) {
      console.error("Upload gagal", error);
      alert("Gagal mengupload komunitas");
    }
  };

  return (
    <div className="min-h-screen flex">
      <AdminSidebar />
      <div className="flex-1 p-6 bg-gray-50">
        <AdminTopBar />

        <div className="bg-white p-6 rounded shadow">
          <button
            onClick={() => navigate(-1)}
            className="text-xl text-black font-semibold mb-8"
          >
            &lt; Tambah Komunitas
          </button>

          <form
            className="grid grid-cols-1 md:grid-cols-2 gap-4"
            onSubmit={handleSubmit}
          >
            <div>
              <label className="text-sm block mb-1">Nama Komunitas</label>
              <input
                name="nama_komunitas"
                type="text"
                value={formData.nama_komunitas}
                onChange={handleChange}
                placeholder="Nama komunitas"
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>
            <div className="md:row-span-3 flex items-center justify-center border rounded relative overflow-hidden">
              {imagePreview ? (
                <img
                  src={imagePreview}
                  alt="Preview"
                  className="object-contain h-full w-full"
                />
              ) : (
                <span className="text-gray-400 text-sm">📷 Upload Foto</span>
              )}
              <input
                type="file"
                name="image"
                accept="image/*"
                onChange={handleImageChange}
                className="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer"
              />
            </div>
            <div>
              <label className="text-sm block mb-1">No. HP</label>
              <input
                name="nomor_hp"
                type="text"
                value={formData.nomor_hp}
                onChange={handleChange}
                placeholder="No. HP"
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>
            <div>
              <label className="text-sm block mb-1">
                Website <span className="text-gray-500">(opsional)</span>
              </label>
              <input
                name="website"
                type="text"
                value={formData.website}
                onChange={handleChange}
                placeholder="Website"
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>

            <div className="md:col-span-2 mt-4">
              <label className="text-sm block mb-1">
                Media Sosial <span className="text-gray-500">(opsional)</span>
              </label>
            </div>

            <div>
              <label className="text-sm block mb-1">Facebook</label>
              <input
                name="facebook"
                type="text"
                value={formData.facebook}
                onChange={handleChange}
                placeholder="Facebook"
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>
            <div>
              <label className="text-sm block mb-1">Instagram</label>
              <input
                name="instagram"
                type="text"
                value={formData.instagram}
                onChange={handleChange}
                placeholder="Instagram"
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>
            <div>
              <label className="text-sm block mb-1">WhatsApp</label>
              <input
                name="whatsapp"
                type="text"
                value={formData.whatsapp}
                onChange={handleChange}
                placeholder="WhatsApp"
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>
            <div>
              <label className="text-sm block mb-1">X</label>
              <input
                name="twitter"
                type="text"
                value={formData.twitter}
                onChange={handleChange}
                placeholder="Twitter"
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>
            <div>
              <label className="text-sm block mb-1">TikTok</label>
              <input
                name="tiktok"
                type="text"
                value={formData.tiktok}
                onChange={handleChange}
                placeholder="TikTok"
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>
            <div>
              <label className="text-sm block mb-1">Telegram</label>
              <input
                name="telegram"
                type="text"
                value={formData.telegram}
                onChange={handleChange}
                placeholder="Telegram"
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>

            <div className="md:col-span-2 flex justify-end">
              <button
                type="submit"
                className="bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600"
              >
                Upload
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
